import CheckboxDropdown from '@/components/CheckboxDropdown'
import { IconFont } from '@/components/IconFont'
import OrbitAvatar from '@/components/OrbitAvatar'
import { priorityOptions, statusOptions } from '@/services/task/task'
import { Input, Space } from 'antd'
import { memo, useEffect, useMemo, useState } from 'react'

const levelOptions = [1, 2, 3].map((item) => ({
  value: item,
  label: `Level ${item}`
}))

export const initialTaskFilters = {
  searchValue: '',
  levels: [],
  assignees: [],
  priorities: [],
  status: []
}

export interface TaskFilters {
  searchValue: string
  levels: number[]
  assignees: number[]
  priorities: number[]
  status: number[]
}

const TaskFilter = memo(function (props: any) {
  const { members, value, onChange, taskType } = props
  const [taskFilters, setTaskFilters] = useState(initialTaskFilters)

  useEffect(() => {
    setTaskFilters(value || initialTaskFilters)
  }, [value])

  const memberOptions = useMemo(
    () =>
      members.map((member) => ({
        value: member.memberId,
        label: (
          <Space>
            <OrbitAvatar size={28} avatar={member.avatar} name={member.fullName} />
            {member.fullName}
          </Space>
        )
      })),
    [members]
  )

  const updateFilters = (newFilters) => {
    const filters = { ...taskFilters, ...newFilters }
    setTaskFilters(filters)
    onChange?.(filters)
  }

  return (
    <Space>
      <Input
        value={taskFilters.searchValue}
        placeholder='Search'
        style={{ width: '300px' }}
        prefix={<IconFont type={'icon-search'} />}
        onChange={(e) => {
          const value = e.target.value
          updateFilters({ searchValue: value })
        }}
      />

      {taskType === 'open' && (
        <CheckboxDropdown
          title='Schedule level'
          options={levelOptions}
          value={taskFilters.levels}
          onChange={(keys: string[]) => {
            updateFilters({ levels: keys })
          }}
        />
      )}

      <CheckboxDropdown
        title='Assignees'
        options={memberOptions}
        value={taskFilters.assignees}
        onChange={(keys: string[]) => {
          updateFilters({ assignees: keys })
        }}
      />

      <CheckboxDropdown
        title='Priority'
        options={priorityOptions}
        value={taskFilters.priorities}
        onChange={(keys: string[]) => {
          updateFilters({ priorities: keys })
        }}
      />

      <CheckboxDropdown
        title='Status'
        options={statusOptions}
        value={taskFilters.status}
        onChange={(keys: string[]) => {
          updateFilters({ status: keys })
        }}
      />
    </Space>
  )
})

export default TaskFilter
